export const isAndroid = () => {
  if (typeof navigator === 'undefined') {
    return false;
  }
  return (
    /android/i.test(navigator.userAgent) || /android/i.test(navigator.platform)
  );
};

export const isIOS = () => {
  if (typeof navigator === 'undefined') {
    return false;
  }
  return (
    /iphone|ipad/i.test(navigator.userAgent) ||
    /iphone|ipad/i.test(navigator.platform)
  );
};

export const isVersionGreaterOrEqual = (
  current: string,
  target: string,
): boolean => {
  if (!current || !target) {
    return false;
  }

  const parse = (v: string) => v.split('.').map((n) => parseInt(n, 10) || 0);
  const [cMaj = 0, cMin = 0, cPatch = 0] = parse(current);
  const [tMaj = 0, tMin = 0, tPatch = 0] = parse(target);

  if (cMaj !== tMaj) {
    return cMaj > tMaj;
  }
  if (cMin !== tMin) {
    return cMin > tMin;
  }
  return cPatch >= tPatch;
};
